import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	warningLabel: {
		id: 'native-issue-table.common.warning-indicator.warning-label',
		defaultMessage: 'Warning',
		description: 'Label for warning icon on a table header cell',
	},
});
